import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { UnitStatusResponseDto } from '../dto/response-dto/unit-status-response-dto';
import { Observable } from 'rxjs';
import { ConfigurationSelectionDTO } from '../../edit-contract/dto/response-dto/configuration-selection-response-dto';

@Injectable({
    providedIn: 'root'
})
export class UnitStatusService {
    public constructor(private http: HttpClient) {}

    public getPacData(pac: string): Observable<UnitStatusResponseDto> {
        return this.http.get<UnitStatusResponseDto>(environment.baseUrl + `Contract/${pac}/unitstatus`);
    }

    public getConfigurationSelectionContract(): Observable<ConfigurationSelectionDTO> {
        return this.http.get<ConfigurationSelectionDTO>(environment.baseUrl + 'Configuration/selection/contract?isNew=false');
    }
}
